import { FC } from 'react';
import { Heading } from '@sede-enterprise/shell-ds-react-framework';
import { Container } from './ErrorMessage.styles';

type ErrorMessageType = {
  message?: string;
};

const ErrorMessage: FC<ErrorMessageType> = ({ 
  message = 'Something went wrong, please try again later.' 
}: ErrorMessageType) => (
  <Container data-testid='error-message'>
    <Heading type='h5'>{message}</Heading>
  </Container>
);

export default ErrorMessage;
